import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import AdminOrganizationsForm from "./AdminOrganizationsForm";
import AdminOrganizationsEdit from "./AdminOrganizationsEdit";

// State
import { addRoute } from "../../../store/actions/route";

class AdminOrganizations extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);
	}

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<Switch>
				<Route path={"/admin/organizations/add"} exact component={AdminOrganizationsForm} />
				<Route path={"/admin/organizations/edit"} component={AdminOrganizationsEdit} />
				<Route path={"/admin/organizations"} component={AdminOrganizationsEdit} />
			</Switch>
		);
	}
}

export default connect(
	null,
	{ addRoute }
)(AdminOrganizations);



// WEBPACK FOOTER //
// ./src/components/admin/organizations/AdminOrganizations.js